import React, { createContext, useContext } from 'react';
import useAdminHook from '../hooks/useAdmin';

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
  const admin = useAdminHook();

  return (
    <AdminContext.Provider value={admin}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = () => useContext(AdminContext);